<mat-sidenav-container class="sidenav-container">
  <mat-sidenav position="end" #sidenav class="sidenav" fixedInViewport="true" [fixedTopGap]="upperBarHeight"
    opened="true" autoFocus="false">
    <div style="margin-top: 15px">
      <div #leftPanel style="float: left; display: flex; flex-flow: column" [ngStyle]="{'min-width.px': 0}">
        <div>
          <!-- Display filter -->
          <div fxLayoutAlign="start end">
            <mat-card [style.display]="displayFilterShown()?'inherit':'none'">
              <ng-container #displayFilterContainer></ng-container>
            </mat-card>
          </div>
          <!-- Global settings -->
          <div fxLayoutAlign="start end">
            <mat-card [style.display]="globalSettingsShown()?'inherit':'none'">
              <ng-container #globalSettingsContainer></ng-container>
            </mat-card>
          </div>
        </div>
      </div>
      <!-- Side menu -->
      <div #rightPanel style="float: right; margin-bottom: 20px;">
        <mat-list dense>
          <!-- <mat-list-item><button mat-stroked-button [disabled]="trackAroDisabled()" (click)="onShowTrackAro()" matTooltip="Track ARO" matTooltipPosition="before" matTooltipShowDelay="2000"><mat-icon class="svg-icon" [ngClass]="trackAroDisabled() ? 'svg-icon-disabled' : 'svg-icon'" svgIcon="aro"></mat-icon></button></mat-list-item> -->
          <mat-list-item><button mat-stroked-button [matTooltip]="'MENUBAR.DISPLAY_FILTER' | translate"
              (click)="onShowDisplayFilter()" matTooltipPosition="before">
              <mat-icon class="svg-icon">filter_none</mat-icon>
            </button></mat-list-item>

          <mat-list-item>
            <button mat-stroked-button [matTooltip]="'MENUBAR.SETTINGS' | translate" (click)="onShowGlobalSettings()"
              matTooltipPosition="before">
              <mat-icon class="svg-icon" svgIcon="settings"></mat-icon>
            </button>
          </mat-list-item>

          <!-- White list currently disabled -->
          <mat-list-item>
            <button mat-stroked-button [@BackgroundColor]="whitelistClicked ? 'Light' : 'normal'"
              [matTooltip]="whitelistClicked ? 'Disable White List' : 'Enable White List'" (click)="onWhiteListClick()"
              matTooltipPosition="before">
              <mat-icon class="svg-icon"
                [@BackgroundColorInverted]="whitelistClicked ? 'Dark' : 'normal'">assignment</mat-icon>
            </button>
          </mat-list-item>

          <mat-list-item>
            <div *ngIf="!isPlayback">
              <button mat-stroked-button (click)="onPlaybackClick()" matTooltip="Start playback"
                matTooltipPosition="before">
                <mat-icon class="svg-icon" svgIcon="playback"></mat-icon>
              </button>
            </div>
            <div *ngIf="isPlayback">
              <button mat-stroked-button matTooltip="Playback is running"
                style="background-color: rgba(250, 96, 40, 0.65) ;" matTooltipPosition="before">
                <mat-icon class="svg-icon" svgIcon="playback"></mat-icon>
              </button>
            </div>
          </mat-list-item>

          <!-- <mat-list-item>
              <button mat-stroked-button [matTooltip]="'MENUBAR.EXIP' | translate" (click)="externalIpClicked()" matTooltipPosition="before">
                <mat-icon class="svg-icon">add_circle_outline</mat-icon>
              </button>
            </mat-list-item>  -->
          <!-- 
          <mat-list-item>
            <button mat-stroked-button [matTooltip]="'MENUBAR.NAT_NAI' | translate" (click)="onNaiNatClick()"
              matTooltipPosition="before">
              <mat-icon class="svg-icon">crop_free</mat-icon>
            </button>
          </mat-list-item> -->
          <!-- sensor window currently disabled - has bug of slow loading -->
          <!-- <mat-list-item><button mat-stroked-button [matTooltip]="'MENUBAR.SENSORWINDOW' | translate"
              (click)="sensorWindowClicked()" matTooltipPosition="before">
              <mat-icon class="svg-icon" svgIcon="sensors-filter"></mat-icon>
            </button></mat-list-item> -->
          <!-- <mat-list-item *ngIf="isAdmin()"><button #plusButton mat-stroked-button
              [matTooltip]="'MENUBAR.ADD' | translate" (click)="onPlusClick($event)" matTooltipPosition="before">
              <mat-icon class="svg-icon">add</mat-icon>
            </button></mat-list-item> -->
          <!-- <mat-list-item><button mat-stroked-button matTooltip="Battle Management" matTooltipPosition="before" matTooltipShowDelay="2000"><mat-icon class="svg-icon" svgIcon="bm"></mat-icon></button></mat-list-item> -->
          <!-- <mat-list-item><button mat-stroked-button matTooltip="Tactical Flight Plans" matTooltipPosition="before" matTooltipShowDelay="2000"><mat-icon class="svg-icon" svgIcon="tfp"></mat-icon></button></mat-list-item> -->
          <!-- <mat-list-item><button mat-stroked-button matTooltip="Weather" matTooltipPosition="before" matTooltipShowDelay="2000"><mat-icon class="svg-icon" svgIcon="weather"></mat-icon></button></mat-list-item> -->
        </mat-list>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- [style.left.px]="xMenuCalc()" -->
<!-- 
<div #plusMenu fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="4px" style="position: absolute;"
  [style.top.px]="yMenuCalc()" [@OutIn]="{value: InOut ? 'In' : 'Out', params:{left: xMenuCalc()}}">


  <button mat-stroked-button [matTooltip]="'MENUBAR.SENSOR' | translate" (click)="onSensorClick()"
    matTooltipPosition="before">
    <mat-icon class="svg-icon" svgIcon="sensors-filter"></mat-icon>
  </button>
</div> -->